import { BotonExportarExcel, Group, Table, Tbody, Th, Thead, Tr } from "@/components/ui";
import type { Area } from "@/lib/types";
import { AreaRow } from "./AreaRow";

/**
 * Tabla read-only · solo se encarga del scaffold (head + cuerpo iterativo).
 * Cada fila controla su propio modo edit · ver `AreaRow`.
 */
export function AreasTable({
  areas,
  obtenerFilas,
}: {
  areas: Area[];
  /** Trae TODAS las páginas con la búsqueda actual · para el export. */
  obtenerFilas: () => Promise<Area[]>;
}) {
  return (
    <div className="overflow-x-auto">
      <Group justify="flex-end" className="mb-2">
        <BotonExportarExcel
          archivo="areas"
          hoja="Áreas"
          obtenerFilas={obtenerFilas}
          columnas={[
            { header: "Nombre", value: (a) => a.nombre },
            { header: "Descripción", value: (a) => a.descripcion },
            { header: "Dispersión Excel", value: (a) => (a.dispersionExcelHabilitada ? "Sí" : "No") },
          ]}
        />
      </Group>
      <Table verticalSpacing="sm">
        <Thead>
          <Tr>
            <Th>Nombre</Th>
            <Th>Descripción</Th>
            <Th>Dispersión Excel</Th>
            <Th />
          </Tr>
        </Thead>
        <Tbody>
          {areas.map((a) => (
            <AreaRow key={a.id} area={a} />
          ))}
        </Tbody>
      </Table>
    </div>
  );
}
